"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.keeperFetchResponse = void 0;
var global_1 = require("../global");
var util_now_1 = require("./util.now");
function keeperFetchResponse(promise, as) {
    var start = (0, util_now_1.now)();
    return promise
        .then(function (response) { return Promise.all([response, response.text()]); })
        .then(function (_a) {
        var response = _a[0], responseText = _a[1];
        var result;
        var error;
        if (as !== 'text') {
            try {
                result = response.ok ? JSON.parse(responseText) : null;
            }
            catch (err) {
                error = err;
            }
        }
        (0, global_1.coreKeeperAPI)(response, {
            duration: (0, util_now_1.now)() - start,
            responseLength: responseText.length,
            error: error,
        });
        return response.ok ? result : Promise.reject(new Error("".concat(response.status)));
    });
}
exports.keeperFetchResponse = keeperFetchResponse;
//# sourceMappingURL=fetch.js.map